var Keyboard = require('../lib/keyboard.es6').default;


var DialogView = $.extend(Backbone.View.extend({
    hideInstant: false,
    showInstant: false,
    closeOnClickOff: false,
    closeOnEsc: true,
    initialize: function (options) {
        this.visible = false;

        _.bindAll(this, 'hide');
    },
    events: {
        'click a.close': 'clickClose',
        'buttonClick button.close': 'clickClose'
    },
    clickClose: function (e) {
        e.preventDefault();
        this.hide();
    },
    isVisible: function () {
        return this.visible;
    },

    toggle: function () {
        if (this.isVisible()) {
            this.hide();
        } else {
            this.show();
        }
        return this;
    },

    doAfterShow: function () {
        if (this.afterShow) {
            this.afterShow();
        }
    },

    triggerOpen: function () {
        this.trigger('open');
        DialogView.trigger('open', this);
    },

    show: function (instant) {
        if (this.isVisible()) {
            this.setCurrent();
            this.doAfterShow();
            this.triggerOpen();
            return;
        }
        if (this.showInstant || instant) {
            this.$el.show();
            this.doAfterShow();
            this.opened();
        } else {
            this.$el.fadeIn('fast', _.bind(function () {
                this.doAfterShow();
                this.opened();
            }, this));
        }
        return this;
    },
    bindClickOff: function () {
        this.clickOffHandler = _.bind(this.clickOff, this);
        $(document).on('click', this.clickOffHandler);
    },
    bindEsc: function () {
        this.escHandler = _.bind(this.esc, this);
        $(document).on('keydown', this.escHandler);
    },
    unbindClickOff: function () {
        if (this.clickOffHandler) {
            $(document).off('click', this.clickOffHandler);
            this.clickOffHandler = null;
        }
    },
    unbindEsc: function () {
        if (this.escHandler) {
            $(document).off('keydown', this.escHandler);
            this.escHandler = null;
        }
    },
    clickOff: function (e) {
        if (!this.isVisible()) {
            return true;
        }
        // Hide if they click off
        var root = this.clickOffRoot || this.$el;
        if (e.target !== root.get(0) && !$.contains(root.get(0), e.target)) {
            this.hideClickOff();
        }
        return true;
    },
    esc: function (e) {
        // Hide if they hit escape
        if (e.which == Keyboard.KEYS.ESC) {
            if (!this.isVisible()) {
                return true;
            }
            this.hideEsc();
            return false;
        }
        return true;
    },
    hideEsc: function () {
        var close = this.$('.mainClose');
        if (!close.length) {
            close = this.$('.close:not([disabled])');
        }
        close.addClass('active').delay(50).queue(function () {
            $(this).removeClass('active').dequeue();
        });
        this._hideEsc();
    },
    _hideEsc: function () {
        this.hide();
    },
    hideClickOff: function () {
        this.hide();
    },
    hide: function (instant) {
        if (!this.isVisible()) {
            return;
        }
        if (this.hideInstant || instant) {
            this.$el.hide();
            if (this.afterHide) {
                this.afterHide();
            }
            this.closed();
        } else {
            this.$el.fadeOut('fast', _.bind(function () {
                if (this.afterHide) {
                    this.afterHide();
                }
                this.closed();
            }, this));
        }
        return this;
    },
    setCurrent: function () {
        if (DialogView.current != this) {
            DialogView.current = this;
        }
    },
    opened: function () {
        this.setCurrent();
        this.visible = true;
        if (this.closeOnClickOff) {
            this.bindClickOff();
        }
        if (this.closeOnEsc) {
            this.bindEsc();
        }
        DialogView.open = true;
        this.triggerOpen();
    },
    closed: function () {
        this.visible = false;
        if (this.closeOnClickOff) {
            this.unbindClickOff();
        }
        if (this.closeOnEsc) {
            this.unbindEsc();
        }
        if (DialogView.current == this) {
            DialogView.open = false;
            DialogView.current = null;
        }
        this.trigger('close');
        DialogView.trigger('close', this);
    }
}, {
    closeCurrent: function () {
        if (DialogView.current) {
            DialogView.current.hide();
        }
    }
}), Backbone.Events);


module.exports = DialogView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/dialogview.js
// module id = EjYC
// module chunks = 1